export const canWriteScoutingStaff = (user, internal = false) =>
	user?.roleName?.toLowerCase() === "admin" ||
	(user?.areaPermissions || []).some(
		(permission) =>
			permission.accessLevel === "FullControl" &&
			(permission.area === "Anagrafiche" ||
				(!internal && permission.area === "Scouting")),
	);
